import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import validator from "validator";

class UserForgot extends Component {
	state = {
		fetching    : false,
		forgotValue : '',
		response    : {}
	};

	changeForgotValue(e) {
		this.setState({
			forgotValue : e.target.value,
		});
	}

	errorBox(message) {
		return <div className="error">{message}</div>
	}

	required(value) {
		if ( validator.isEmpty(value) ) {
			return this.errorBox('Поле обязательно для заполнения!');
		}
	};

	recoveryPassword(e) {
		e.preventDefault();
		const data = {
			value : this.state.forgotValue
		};

		this.setState({fetching : true});

		Xhr.forgotPassword(data).then((resp) => this.setState({response : resp.data || '', fetching : false}));
	}

	render() {
		return (
			<div className="body__container__side-right">
				<div className="live-event-header result-live__header">
					<div className="no-dot">Восстановление пароля</div>
				</div>
				<Form ref={c => { this.form = c }} onSubmit={this.recoveryPassword.bind(this)}>
					<div className="forgot">
						<div className="forgot__label">
							<label htmlFor="forgot-input">
								Для смены пароля укажите свой Номер счета, Логин или E-mail, указанный при регистрации:
							</label>
						</div>

						<div className="forgot__input">
							<Input id="forgot-input" type="text" placeholder="Номер счета, логин или e-mail"
							       validations={[this.required.bind(this)]}
							       onChange={this.changeForgotValue.bind(this)}
							       value={this.state.forgotValue}/>
							<div className="forgot__messages">{this.state.response.messages}</div>
						</div>
					</div>

					<div className="buttons forgot__buttons">
						<Button className="buttons__show">Восстановить</Button>
					</div>
					<div className="forgot__loading">{this.state.fetching && <Loading/>}</div>
				</Form>
			</div>
		);
	}
}

export default UserForgot;


// WEBPACK FOOTER //
// ./src/app/pages/User/UserForgot.js